// extracted by mini-css-extract-plugin
export default {"errorBoundaryError":"errorBoundaryError_FiLL","errorBoundaryFallback":"errorBoundaryFallback_lv4I"};